{
  "page_count": "共 {n, plural, one{# 頁} other{# 頁}}"
}
